import React, { Component } from "react";
import { Grid, Row, Col, FormGroup, ControlLabel } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Select from "react-select";
import ScreenLoader from "views/Components/screenLoader";
import { getTickets, UpdateNewTicket, UpdateNewTicketRow } from "Listfunction";

const TICKET_TYPES = {
  1: "Bug",
  2: "Improvement",
  3: "Support",
};

class EditTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticket_type: "1",
      platform: "",
      severity: "",
      description: "",
      platformErr: "",
      severityErr: "",
      descriptionErr: "",
      isLoading: false,
      attachments: [],
      isSubmitted: false,
      errormessages: [],
      cardHidden: true,
      isAttachmentChanged: false,
      status: "",
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.upload = this.upload.bind(this);
    this.removeFileItem = this.removeFileItem.bind(this);
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;

    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const id = localStorage.getItem("tic_id");

    getTickets(id, obj)
      .then((res) => {
        if (res.success === true) {
          const data = res.data.Ticket;
          const platform = this.mapPlatformToOption(data.platform);
          const severity = this.mapSeverityToOption(data.priority);

          this.setState({
            ticket_type: this.mapTicketTypeToOption(data.type),
            platform,
            severity,
            description: data.description || "",
            attachments: data.files || [],
            status: data.status || "",
          });
        }
      })
      .catch(() => {
        this.showError("Failed to load ticket");
      });

    setTimeout(() => {
      this.setState({ cardHidden: false });
    }, 700);
  }

  mapTicketTypeToOption(type) {
    switch ((type || "").toLowerCase()) {
      case "bug":
        return "1";
      case "support":
        return "3";
      default:
        return "2";
    }
  }

  mapPlatformToOption(platform) {
    const options = [
      { value: "1", label: "Flash App" },
      { value: "2", label: "Flash Admin" },
      { value: "3", label: "First Advice Doctor Panel" },
      { value: "4", label: "Rider App" },
      { value: "5", label: "Flash Website" },
    ];

    return options.find((option) => option.label === platform) || "";
  }

  mapSeverityToOption(severity) {
    const options = [
      { value: "1", label: "High" },
      { value: "2", label: "Medium" },
      { value: "3", label: "Low" },
    ];

    return options.find((option) => option.label === severity) || "";
  }

  showSuccess() {
    this._notificationSystem.addNotification({
      message: (
        <div>
          <b>Ticket updated successfully</b>
        </div>
      ),
      level: "success",
      position: "tr",
      autoDismiss: 3,
    });
  }

  showError(message = "Something went wrong") {
    this._notificationSystem.addNotification({
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: "error",
      position: "tr",
      autoDismiss: 4,
    });
  }

  upload() {
    document.getElementById("ticket_attachment").click();
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      descriptionErr: e.target.name === "description" ? "" : this.state.descriptionErr,
    });
  }

  handleFileChange(e) {
    this.setState({
      attachments: [...e.target.files],
      isAttachmentChanged: true,
    });
  }

  removeFileItem(index) {
    const attachments = [...this.state.attachments];
    attachments.splice(index, 1);

    this.setState({
      attachments,
      isAttachmentChanged: true,
    });
  }

  async onSubmit() {
    let error = false;
    let platformErr = "";
    let severityErr = "";
    let descriptionErr = "";

    if (!this.state.platform) {
      error = true;
      platformErr = (
        <small className="text-danger">Please select platform</small>
      );
    }

    if (!this.state.severity) {
      error = true;
      severityErr = (
        <small className="text-danger">Please select severity</small>
      );
    }

    if (!this.state.description) {
      error = true;
      descriptionErr = (
        <small className="text-danger">Please enter description</small>
      );
    }

    if (error) {
      this.setState({
        platformErr,
        severityErr,
        descriptionErr,
        isSubmitted: true,
      });
      return;
    }

    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const id = localStorage.getItem("tic_id");
    const type = TICKET_TYPES[this.state.ticket_type] || "Bug";
    const platform = this.state.platform.label;
    const severity = this.state.severity.label;

    this.setState({ isLoading: true, errormessages: [] });

    try {
      let res;

      if (this.state.isAttachmentChanged) {
        const fdata = new FormData();
        const attachmentFiles = this.state.attachments;

        for (let i = 0; i < attachmentFiles.length; i++) {
          fdata.append("files[]", attachmentFiles[i]);
        }

        fdata.append("type", type);
        fdata.append("platform", platform);
        fdata.append("severity", severity);
        fdata.append("description", this.state.description);
        fdata.append("status", this.state.status);

        res = await UpdateNewTicket(obj, fdata, id);
      } else {
        res = await UpdateNewTicketRow(
          obj,
          null,
          severity,
          platform,
          type,
          this.state.description,
          this.state.attachments,
          this.state.status,
          id,
        );
      }

      if (res && res.success) {
        this.showSuccess();
        setTimeout(() => {
          this.props.history.push("/admin/tickets");
        }, 1500);
      } else {
        this.setState({
          errormessages: res && res.message ? [res.message] : [],
        });
        this.showError();
      }
    } catch (errorObj) {
      const messages =
        errorObj &&
        errorObj.response &&
        errorObj.response.data &&
        errorObj.response.data.message
          ? Array.isArray(errorObj.response.data.message)
            ? errorObj.response.data.message
            : [errorObj.response.data.message]
          : [];

      this.setState({ errormessages: messages });
      this.showError();
    }

    this.setState({ isLoading: false });
  }

  render() {
    const { errormessages } = this.state;

    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref=""
        />

        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Card
            content={
              <form>
                {errormessages.length !== 0 && (
                  <div className="alert alert-danger">
                    {errormessages.map((data, idx) => (
                      <React.Fragment key={idx}>
                        <li>{data}</li>
                      </React.Fragment>
                    ))}
                  </div>
                )}

                <Row>
                  <Col xs={12} sm={6} md={4}>
                    <FormGroup>
                      <ControlLabel>Ticket Type</ControlLabel>
                      <div className="ticket_type_radio">
                        <Radio
                          number="1"
                          option="1"
                          name="ticket_type"
                          onChange={this.onChange}
                          checked={this.state.ticket_type === "1"}
                          label="Bug"
                        />
                        <Radio
                          number="2"
                          option="2"
                          name="ticket_type"
                          onChange={this.onChange}
                          checked={this.state.ticket_type === "2"}
                          label="Improvement "
                        />
                        <Radio
                          number="3"
                          option="3"
                          name="ticket_type"
                          onChange={this.onChange}
                          checked={this.state.ticket_type === "3"}
                          label="Support"
                        />
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6} md={6} lg={4}>
                    <FormGroup>
                      <ControlLabel>Platform</ControlLabel>
                      <Select
                        placeholder="Platform"
                        name="platform"
                        value={this.state.platform}
                        onChange={(value) =>
                          this.setState({
                            platform: value,
                            platformErr: "",
                          })
                        }
                        options={[
                          { value: "1", label: "Flash App" },
                          { value: "2", label: "Flash Admin" },
                          { value: "3", label: "First Advice Doctor Panel" },
                          { value: "4", label: "Rider App" },
                          { value: "5", label: "Flash Website" },
                        ]}
                      />
                      {this.state.platformErr}
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={4}>
                    <FormGroup>
                      <ControlLabel>Severity</ControlLabel>
                      <Select
                        className="secondary"
                        placeholder="Severity "
                        name="severity"
                        value={this.state.severity}
                        onChange={(value) =>
                          this.setState({
                            severity: value,
                            severityErr: "",
                          })
                        }
                        options={[
                          { value: "1", label: "High" },
                          { value: "2", label: "Medium" },
                          { value: "3", label: "Low" },
                        ]}
                      />
                      {this.state.severityErr}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12} lg={8}>
                    <FormGroup>
                      <ControlLabel>Description</ControlLabel>
                      <textarea
                        className="form-control"
                        value={this.state.description}
                        placeholder="Enter Message"
                        name="description"
                        onChange={this.onChange}
                        rows={5}
                        style={{ resize: "none" }}
                      />
                      {this.state.descriptionErr}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <FormGroup>
                      <ControlLabel>Attachment</ControlLabel>
                      <input
                        style={{ display: "none" }}
                        id="ticket_attachment"
                        type="file"
                        className="form-control"
                        name="ticket_attachment"
                        multiple
                        onChange={this.handleFileChange}
                      />
                      <Button
                        onClick={this.upload}
                        style={{ color: "#2B3A41", display: "block" }}
                      >
                        <i
                          className={
                            this.state.attachments === ""
                              ? "fa fa-plus"
                              : "fa fa-pencil fa-fw"
                          }
                        ></i>{" "}
                        {this.state.attachments === ""
                          ? "Choose File"
                          : "Change File"}
                      </Button>
                    </FormGroup>
                  </Col>
                  <Col xs={12} className="attecth_filelist">
                    {this.state.attachments.length > 0 &&
                      this.state.attachments.map((attch, idx) => (
                        <div className="attecth_filelist_row" key={idx}>
                          <h6>
                            <a
                              href={
                                !this.state.isAttachmentChanged
                                  ? attch
                                  : URL.createObjectURL(attch)
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              {!this.state.isAttachmentChanged
                                ? `File ${idx + 1}`
                                : attch.name}
                            </a>
                          </h6>
                          <p onClick={() => this.removeFileItem(idx)}>x</p>
                        </div>
                      ))}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Button onClick={this.onSubmit} className="btn-color" fill>
                      Save
                    </Button>
                  </Col>
                </Row>
              </form>
            }
          />
        </Grid>
        {this.state.isLoading ? <ScreenLoader /> : ""}
      </div>
    );
  }
}

export default EditTicket;
